<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="cover" id="cvi">
<div class="cover">
<p class="fig"><img alt="Cover Page for &amp;quot;What Is Critique?&amp;quot; and &amp;quot;The Culture of the Self&amp;quot;" role="doc-cover" src="images/chi-Foucault-cover.jpg"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-foucault-critique-0001.vue?255c4e4c